import React from "react";

function BucketTable_Fault_Click(props) {
  let { data } = props;
  return (
    <>
      {(data.length == 0) ? "<tr><td colSpan={2}>No data found</td></tr>" : data.map((x, index) => {

        return (<tr key={x.key}>
          <td scope="row ">{x.key.vehicleId}</td>
          <td >{(x.key.DLR_ORG_CITY)} </td>
          <td >{(x.key.Depot_Name)} </td>
          <td >{(x.duration.value).toFixed(2)} </td>
          <td >{(x.occurance.value).toFixed(0)} </td>


        </tr>)
      })}
    </>
  );
}

export default BucketTable_Fault_Click;